import { DateTrustCode } from '../common/types'
import { Organization } from '../organizations/types'

export type PerformanceIndicator = {
  id: number
  organizationId?: Organization['id']
  type: PerformanceIndicatorType
  value: PerformanceIndicatorData
  measuredOn: Date
  measuredOnTrustCode: DateTrustCode
}

export enum PerformanceIndicatorType {
  linkedinEmployees = 'linkedin-employees',
  linkedinRangeEmployees = 'linkedin-range-employees',
  crunchbaseRangeEmployees = 'crunchbase-range-employees',
  monthlyRevenue = 'monthly-revenue',
  committedCapital = 'committed-capital',
  committedInvestors = 'committed-investors',
  otherTraction = 'other-traction',
}

export type PerformanceIndicatorData = Range | number | string

export type Range = {
  min: number
  max?: number
}
